import { render, staticRenderFns } from "./FormsView.vue?vue&type=template&id=aa3bad6e&"
import script from "./FormsView.vue?vue&type=script&lang=ts&"
export * from "./FormsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports